module.exports = __webpack_public_path__ + "img/celebrity-video.d03ca654.webp";